module.exports = __webpack_public_path__ + "img/kaquanbao.7d241b8b.png";